import reducer from './reducers';

export { default as Dealership } from './containers';

export default reducer;
